import post from '@/api/post/'
import get from '@/api/get/'
import {latLng} from 'leaflet'
import i18n from '@/localization'
export default {
  getObjects () {
    return post('get_devices_coordinate', {})
      .then(response => {
        const groups = response.data.data.reduce((acc, curr) => ({
          ...acc,
          ...{
            [curr.id_group ? curr.id_group : 0]: {
              children: (
                acc[curr.id_group ? curr.id_group : 0] ? acc[curr.id_group ? curr.id_group : 0].children : []
              ).concat(curr.null_device ? [] : {
                text: curr.name_device,
                id: parseInt(curr.id_device),
                data: {
                  id: parseInt(curr.id_device),
                  imei: curr.imei_device,
                  device_type: parseInt(curr.device_type),
                  mode: curr.mode_device || 3,
                  phone: curr.phone_device || i18n.t('devices.undefined_label'),
                  name: curr.name_device,
                  group_id: parseInt(curr.id_group) || 0,
                  group: curr.group_device || i18n.t('devices.no_group_label'),
                  angle: parseInt(curr.angle),
                  speed: parseInt(curr.speed),
                  icon: curr.icon,
                  mode_link: curr.mode_link,
                  ...latLng(parseFloat(curr.latitude_device_gps), parseFloat(curr.longitude_device_gps)),
                  address: curr.address,
                  date: new Date(curr.date_device_gps.replace(/-/g, '/')) || i18n.t('devices.no_data_label'),
                  params: curr.params || {},
                  ...(curr.options || {})
                }
              }),
              data: {
                id: curr.id_group ? curr.id_group : 0
              },
              id: curr.id_group ? curr.id_group : 0,
              collapsed: false,
              text: curr.group_device || i18n.t('devices.no_group_label')
            }
          }
        }), {0: {text: i18n.t('devices.no_group_label'), id: 0, data: {id: 0}, collapsed: false, children: []}})
        return Object.keys(groups).reduce((acc, curr) => acc.concat(groups[curr]), [])
      })
  },
  getObjectHistory (data) {
    return post('get_device_coordinate_history', {
      id_device: data.id,
      date_start: data.dStart,
      date_stop: data.dStop
    }).then(response => response.data.data.reduce((acc, curr, index) => acc
      .concat({
        id: index,
        ...latLng(parseFloat(curr.latitude_device_gps), parseFloat(curr.longitude_device_gps)),
        address: curr.address,
        date: new Date(curr.date_device_gps.replace(/-/g, '/')) || i18n.t('devices.no_data_label'),
        params: curr.params || {},
        altitude: parseInt(curr.altitude),
        angle: parseInt(curr.angle),
        speed: parseInt(curr.speed)})
      , [])
    )
  },
  getObjectAddress (data) {
    return post('latlng', {lat: data.lat, lng: data.lng})
      .then(response => response.data)
  },
  setSingleObjectGroup (data) {
    return post('set_device_group', { idx_and_statuses: { [data.obj_id]: data.id } }).then(response => response.data.data[data.obj_id])
  },
  getGeoZone (link) {
    return get(link)
  }
}



// WEBPACK FOOTER //
// ./src/api/services/objects/index.js